import { Box } from "@mui/material";
import { useState } from "react";
import DotLegalAutocomplete, { AutocompleteOption } from "../../common/autocomplete/DotLegalAutocomplete";
import { Organization } from "./Organization.types";

export interface IConfigureFutureEstimatedRenewalCosts {
    organization: Organization;
    onOrganizationChanged: (organization: Organization) => void;
}

export default function ConfigureFutureEstimatedRenewalCosts(props: IConfigureFutureEstimatedRenewalCosts) {
    const [futureEstimatedRenewalCostsOptions] = useState<AutocompleteOption<boolean>[]>([
        { label: "Hide widget", value: false },
        { label: "Show widget", value: true },
    ]);
    const [selectedOption, setSelectedOption] = useState<AutocompleteOption<boolean>>(
        futureEstimatedRenewalCostsOptions.find((option) => option.value === (props.organization.futureEstimatedRenewalCostsActive ?? false))!
    );

    const onFutureEstimatedRenewalCostsActiveChange = (newValue: AutocompleteOption<boolean>[]) => {
        setSelectedOption(newValue[0] ?? { label: "Hide widget", value: false });
        props.onOrganizationChanged({
            ...props.organization,
            futureEstimatedRenewalCostsActive: newValue[0]?.value ?? false,
        });
    };

    return (
        <Box sx={(theme) => ({ display: "flex", width: "100%", flexDirection: "column", gap: theme.spacing(5.5), alignItems: "center" })}>
            <Box id="singleSelectDropdown" sx={{ width: 270 }}>
                <DotLegalAutocomplete
                    onChange={onFutureEstimatedRenewalCostsActiveChange}
                    label="Future estimated renewal costs"
                    options={futureEstimatedRenewalCostsOptions}
                    singleSelect
                    // @ts-ignore
                    value={selectedOption}
                    width={"100%"}
                    tooltip={`Adds a “Future estimated renewal costs” widget to the dashboard, showing the estimated renewal prices for the rest of the current year and the following three years. Designs in countries where they are renewed every year also get calculated rows for the coming years in the renewals overview and in the renewals Excel export. These rows cannot be edited. The widget and the calculated rows are only visible if “Renewal price” is set to “Employee” or “Employee and Client”. If “Employee” is chosen, only users with the role Employee can see them. If “Renewal price” is hidden, they are hidden as well.`}
                />
            </Box>
        </Box>
    );
}
